module.exports = __webpack_public_path__ + "static/media/29ADMSPC33.f2029932.jpg";